import React from 'react';
import { Award, TrendingUp, Users, Sparkles } from 'lucide-react';

const ClinicValueSection = () => {
  const values = [
    {
      icon: Award,
      title: 'Premium Positioning',
      description: 'Elevate your practice with cutting-edge regenerative technology that sets you apart as an innovation leader'
    },
    {
      icon: TrendingUp,
      title: 'Better Outcomes',
      description: 'Deliver superior clinical results with enhanced efficacy, reducing treatment sessions and improving success rates'
    },
    {
      icon: Users,
      title: 'Patient Demand',
      description: 'Meet growing patient expectations for advanced, minimally invasive regenerative treatments with proven results'
    },
    {
      icon: Sparkles,
      title: 'Differentiation',
      description: 'Stand out in a competitive market with exclusive technology that transforms standard procedures into premium offerings'
    }
  ];

  return (
    <section className="py-32 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-20 animate-fade-in">
          <h2 className="text-6xl md:text-7xl font-light mb-6 text-gray-900">
            Why Clinics Choose <span className="gradient-text font-light">MCT</span>
          </h2>
          <p className="text-silver-600 text-xl font-light max-w-3xl mx-auto leading-relaxed">
            Join leading healthcare providers worldwide who trust MCT System to elevate their regenerative medicine practice
          </p>
        </div>

        {/* Value Grid */}
        <div className="grid md:grid-cols-2 gap-10">
          {values.map((value, index) => {
            const Icon = value.icon;
            return (
              <div
                key={index}
                className="group relative animate-fade-in"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                {/* Background gradient on hover */}
                <div className="absolute inset-0 bg-gradient-to-br from-teal-50 to-white rounded-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                
                {/* Card content */}
                <div className="relative p-10 bg-gradient-to-br from-white to-teal-50/30 rounded-3xl shadow-soft hover:shadow-soft-xl transition-all duration-500 border border-teal-100/50 group-hover:border-blue-200 h-full">
                  <div className="flex items-start gap-6">
                    {/* Icon */}
                    <div className="flex-shrink-0">
                      <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-teal-600 rounded-2xl flex items-center justify-center group-hover:scale-110 group-hover:rotate-3 transition-all duration-500 shadow-soft">
                        <Icon className="w-8 h-8 text-white" strokeWidth={1.5} />
                      </div>
                    </div>
                    
                    {/* Content */}
                    <div className="flex-1">
                      <h3 className="text-2xl font-light mb-4 text-gray-900 group-hover:text-teal-600 transition-colors duration-300">
                        {value.title}
                      </h3>
                      <p className="text-silver-600 font-light leading-relaxed">
                        {value.description}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* CTA Section */}
        <div className="mt-20 text-center bg-gradient-to-br from-teal-50/50 to-silver-50/50 p-16 rounded-3xl shadow-soft animate-fade-in">
          <h3 className="text-3xl font-light mb-6 text-gray-900">
            Ready to Transform Your Practice?
          </h3>
          <p className="text-silver-600 font-light mb-8 max-w-2xl mx-auto">
            Discover how MCT System can elevate your regenerative medicine offerings and deliver exceptional patient outcomes
          </p>
          <div className="flex justify-center">
            <a
              href="/contact"
              className="inline-block bg-gradient-to-r from-teal-500 to-teal-600 hover:from-teal-600 hover:to-teal-700 text-white px-10 py-4 rounded-2xl font-light transition-all duration-300 shadow-soft-lg hover:shadow-soft-xl hover:scale-[1.02]"
            >
              Contact Us
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClinicValueSection;
